import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../../../store/store-provider';
import { SortDirection } from '../../../../../constans/common-constants';
import { AttendeeSortFields } from '../../../../../constans/attendee-enums';
import { AttendeeCell, IAttendeeCell } from './attendee-cell';
import { getMixpanelService } from '../../../../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../../../constans/mixpanel-contants';

const AttendeesTableHeader: FC = () => {
  const { attendeesStore, permissionsStore, liveStreamStatusStore } = useStore();
  const { getAttendeesService } = attendeesStore;
  const { isPodiumDisconnectEnabled } = permissionsStore;
  const { getLivePresentationId } = liveStreamStatusStore;
  const {
    sortDirectionValue,
    switchSortDirection,
    setActiveSortField,
    activeSortFieldParam,
    setSortDirection
  } = getAttendeesService();

  const clickCellHandler = (sortField: AttendeeSortFields) => {
    if (activeSortFieldParam === sortField) {
      switchSortDirection();
    } else {
      setSortDirection(SortDirection.ASC);
    }

    setActiveSortField(sortField);
    trackAttendeeSortFields(sortField);
  };

  const trackAttendeeSortFields = (sortField: AttendeeSortFields) => {
    let eventType = null;

    if (sortField === AttendeeSortFields.NAME) {
      eventType = MIXPANEL_EVENT_TYPES.SORTING_NAME;
    }
    if (sortField === AttendeeSortFields.EMAIL) {
      eventType = MIXPANEL_EVENT_TYPES.SORTING_EMAIL;
    }
    if (sortField === AttendeeSortFields.ARRIVAL) {
      eventType = MIXPANEL_EVENT_TYPES.SORTING_ARRIVAL;
    }

    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.ATTENDEES, eventType);
  };

  const defaultCellParams = {
    cellWrapperClass: 'sort-cell',
    onSort: clickCellHandler,
    sortType: sortDirectionValue,
    shouldSort: true
  };

  const attendeeCells: IAttendeeCell[] = [
    {
      title: 'Name',
      name: AttendeeSortFields.NAME,
      ...defaultCellParams
    }, {
      title: 'Email',
      name: AttendeeSortFields.EMAIL,
      ...defaultCellParams
    }, {
      title: 'Arrival',
      name: AttendeeSortFields.ARRIVAL,
      ...defaultCellParams
    }, {
      title: 'Departures',
      name: AttendeeSortFields.DEPARTURED,
      ...defaultCellParams
    }
  ];

  const className = isPodiumDisconnectEnabled() && !!getLivePresentationId()
    ? 'table-row body-row-button-padding attende-column-width'
    : 'table-row attende-column-width';

  return (
    <div className={className}>
      {attendeeCells.map((cell: IAttendeeCell) => {
        const isActive = cell.name === activeSortFieldParam;

        return (
          <AttendeeCell isActive={isActive} {...cell} key={cell.title}/>
        );
      }
      )}
    </div>
  );
};

export default observer(AttendeesTableHeader);